export interface PricingContent {
  title: string;
  sections: Section[];
}

export interface Section {
  title: string;
  subsections: Subsection[];
}

export interface Subsection {
  title: string;
  items: ContentItem[];
}

export interface TableCell {
  content: string;
}

export interface TableRow {
  cells: TableCell[];
}

export interface ContentItem {
  number: string;
  content: string;
  subItems?: ContentItem[];
  table?: {
    headers?: string[];
    rows: TableRow[];
  };
}

export const privacyPolicyContentKR: PricingContent = {
  title: '개인정보처리방침',
  sections: [
    {
      title: '1 총칙',
      subsections: [
        {
          title: '1.1 목적',
          items: [
            {
              number: '',
              content:
                '본 개인정보처리방침은 SPACEMAP(이하 "회사")이 운영하는 플랫폼 및 관련 서비스(웹사이트, API 서비스, 위성·우주데이터 제공 서비스, 교육 및 학습 콘텐츠 제공 서비스 포함)에서 이용자의 개인정보를 어떠한 방식으로 수집, 이용, 보관, 처리하는지를 명확히 하여, 이용자의 권익 보호와 투명한 데이터 관리를 보장하는 것을 목적으로 한다.',
            },
          ],
        },
        {
          title: '1.2 개인정보 처리의 기본원칙',
          items: [
            {
              number: '1.2.1',
              content: '회사는 이용자의 개인정보를 처리함에 있어 다음의 기본 원칙을 따른다.',
              subItems: [
                {
                  number: 'a',
                  content:
                    '적법성(Lawfulness): 법령에 근거하거나 정보주체의 동의에 따라 개인정보를 수집한다.',
                },
                {
                  number: 'b',
                  content:
                    '공정성(Fairness): 개인정보의 수집 및 이용 과정은 정당하고 투명해야 한다.',
                },
                {
                  number: 'c',
                  content:
                    '목적 제한(Purpose Limitation): 명시된 목적 외의 용도로 개인정보를 이용하지 않는다.',
                },
                {
                  number: 'd',
                  content:
                    '최소 수집(Data Minimization): 서비스 제공에 필요한 최소한의 정보만 수집한다.',
                },
                {
                  number: 'e',
                  content:
                    '정확성(Accuracy): 개인정보가 정확하고 최신 상태로 유지되도록 관리한다.',
                },
                {
                  number: 'f',
                  content:
                    '보관 제한(Storage Limitation): 보유기간이 경과하거나 목적이 달성된 개인정보는 지체 없이 파기한다.',
                },
                {
                  number: 'g',
                  content:
                    '무결성 및 기밀성(Integrity & Confidentiality): 개인정보는 안전하게 보호되며, 무단 접근이나 유출을 방지한다.',
                },
              ],
            },
          ],
        },
        {
          title: '1.3 적용 범위',
          items: [
            {
              number: '1.3.1',
              content: '본 방침은 회사가 제공하는 다음의 모든 서비스에 적용된다.',
              subItems: [
                {
                  number: 'a',
                  content: 'Spacemap 웹 플랫폼 (https://platform.spacemap42.com)',
                },
                {
                  number: 'b',
                  content: 'Spacemap API 서비스 및 개발자 포털',
                },
                {
                  number: 'c',
                  content: '우주데이터 다운로드 및 분석 서비스',
                },
                {
                  number: 'd',
                  content: '클라우드 기반 데이터 처리 및 저장 서비스',
                },
                {
                  number: 'e',
                  content: '교육 및 학습 콘텐츠 제공 서비스',
                },
                {
                  number: 'f',
                  content:
                    '그 밖에 회사가 운영하는 모든 부속 서비스, 애플리케이션, 기술지원 시스템',
                },
              ],
            },
            {
              number: '1.3.2',
              content:
                '단, 외부 사이트로 연결되는 링크 페이지나 제3자 플랫폼에서의 이용 행위는 회사의 관리 범위를 벗어나므로 본 방침이 적용되지 않는다.',
            },
          ],
        },
        {
          title: '1.4 정의',
          items: [
            {
              number: '1.4.1',
              content:
                '본 방침에서 사용하는 주요 용어의 정의는 다음과 같고, 달리 규정이 없는 한 개인정보보호법의 정의에 따른다.',
            },
            {
              number: '1.4.2',
              content:
                '이용자: Spacemap 플랫폼 및 API를 이용하는 회원, 비회원, 기관계정, 개발자를 포함한다.',
            },
            {
              number: '1.4.3',
              content:
                '회원: 회사와 서비스 이용계약을 체결하고 계정을 생성한 자를 말한다.',
            },
            {
              number: '1.4.4',
              content:
                '기관계정(B2B 고객): 기업, 연구기관, 정부기관 등 단체가 Spacemap 서비스 이용을 위해 등록한 법인 또는 단체 계정을 말한다.',
            },
            {
              number: '1.4.5',
              content:
                'API 데이터: 회사가 제공하는 위성, 우주 관련 데이터, 메타데이터, API 응답값(Response Data), 로그 데이터 등을 포함한다.',
            },
          ],
        },
        {
          title: '1.5 방침의 공개 및 변경',
          items: [
            {
              number: '1.5.1',
              content:
                '회사는 본 개인정보처리방침을 홈페이지 초기화면 또는 이용자 접근이 용이한 위치에 공개한다. 방침의 내용이 변경되는 경우, 변경 사항을 시행일 최소 7일 전에 공지한다.',
            },
          ],
        },
      ],
    },
    {
      title: '2 개인정보의 수집 및 이용목적',
      subsections: [
        {
          title: '2.1 기본 원칙',
          items: [
            {
              number: '2.1.1',
              content:
                '회사는 수집한 개인정보를 다음 각 항목의 목적 범위 내에서만 이용하며, 이용 목적이 변경될 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는다.',
            },
          ],
        },
        {
          title: '2.2 서비스 제공 관련 목적',
          items: [
            {
              number: '2.2.1',
              content: '회원가입 및 본인확인',
              subItems: [
                {
                  number: 'a',
                  content: '서비스 이용을 위한 회원 식별 및 인증',
                },
                {
                  number: 'b',
                  content: '이용자 유형(개인/기관) 확인 및 계정 권한 부여',
                },
                {
                  number: 'c',
                  content: '비밀번호 분실 시 본인 확인 및 계정 복구 지원',
                },
              ],
            },
            {
              number: '2.2.2',
              content: '서비스 제공 및 운영 관리',
              subItems: [
                {
                  number: 'a',
                  content: 'Spacemap 플랫폼 및 API 서비스의 제공',
                },
                {
                  number: 'b',
                  content: '위성·우주데이터 다운로드, 분석, 저장 기능의 운영',
                },
                {
                  number: 'c',
                  content: '서비스 이용기록 및 사용이력 관리',
                },
              ],
            },
            {
              number: '2.2.3',
              content: '맞춤형 서비스 제공',
              subItems: [
                {
                  number: 'a',
                  content: '이용자의 선호도, 사용패턴에 따른 서비스 맞춤화',
                },
                {
                  number: 'b',
                  content: '신규 데이터셋, 기능, 요금제 추천',
                },
              ],
            },
            {
              number: '2.2.4',
              content: '계약 이행 및 기술지원',
              subItems: [
                {
                  number: 'a',
                  content: 'B2B 고객사의 서비스 운영 및 시스템 통합 지원',
                },
                {
                  number: 'b',
                  content: '기술문의 응답 및 유지보수 지원',
                },
              ],
            },
          ],
        },
        {
          title: '2.3 요금정산 및 과금관리 목적',
          items: [
            {
              number: '2.3.1',
              content: '유료 서비스 이용요금 산정 및 결제 처리',
            },
            {
              number: '2.3.2',
              content: '세금계산서 발행 및 회계 정산',
            },
            {
              number: '2.3.3',
              content: '환불 및 취소 요청 처리',
            },
            {
              number: '2.3.4',
              content: '이용량 기반 과금 및 서비스 등급 관리',
            },
          ],
        },
        {
          title: '2.4 보안 및 부정이용 방지 목적',
          items: [
            {
              number: '2.4.1',
              content: 'API Key, Token, 접속 로그를 통한 비정상 접근 탐지',
            },
            {
              number: '2.4.2',
              content: '서비스 남용, 해킹, 데이터 무단수집 행위 차단',
            },
            {
              number: '2.4.3',
              content: '시스템 모니터링 및 접근제어 관리',
            },
            {
              number: '2.4.4',
              content: '보안사고 조사 및 재발 방지',
            },
          ],
        },
        {
          title: '2.5 고객지원 및 문의 대응 목적',
          items: [
            {
              number: '2.5.1',
              content: '문의, 신고, 제안사항 접수 및 응답',
            },
            {
              number: '2.5.2',
              content: '기술문제 진단 및 해결',
            },
            {
              number: '2.5.3',
              content: '고객 만족도 조사 및 서비스 품질 개선',
            },
          ],
        },
        {
          title: '2.6 서비스 개선 및 연구개발 목적',
          items: [
            {
              number: '2.6.1',
              content: '서비스 이용 관련 통계 작성 및 이용행태 분석',
            },
            {
              number: '2.6.2',
              content: '위성·우주데이터 활용 성능 개선 및 품질 향상',
            },
            {
              number: '2.6.3',
              content:
                '비식별화된 데이터 분석을 통한 신기술 연구 및 알고리즘 개발',
            },
            {
              number: '2.6.4',
              content: 'API 응답 속도, 데이터 품질, 클라우드 처리 효율성 검증',
            },
          ],
        },
        {
          title: '2.7 마케팅 목적 (이용자 동의 시)',
          items: [
            {
              number: '2.7.1',
              content: '신규 서비스, 이벤트, 기능 추가 등에 대한 공지 발송',
            },
            {
              number: '2.7.2',
              content: '뉴스레터 및 업데이트 알림',
            },
            {
              number: '2.7.3',
              content:
                '단, 이용자는 언제든지 마케팅 정보 수신을 거부할 수 있으며, 회사는 거부 의사 표시를 즉시 반영한다.',
            },
          ],
        },
        {
          title: '2.8 데이터 보존 및 감사, 법령상 의무 이행 목적',
          items: [
            {
              number: '2.8.1',
              content: '서비스 장애 대응을 위한 로그 보관',
            },
            {
              number: '2.8.2',
              content: '계약 이행 증빙 및 회계',
            },
            {
              number: '2.8.3',
              content: '법적 분쟁 발생 시 사실관계 확인 및 대응',
            },
            {
              number: '2.8.4',
              content: '수사기관, 행정기관의 적법한 요청에 대한 협조',
            },
          ],
        },
      ],
    },
    {
      title: '3 수집하는 개인정보 항목',
      subsections: [
        {
          title: '3.1 수집 방법 및 항목',
          items: [
            {
              number: '3.1.1',
              content: '회사는 다음과 같은 방법을 통해 개인정보를 수집한다.',
              subItems: [
                {
                  number: 'a',
                  content:
                    '회원가입 또는 서비스 이용계약 체결 시 이용자가 직접 입력하는 경우',
                },
                {
                  number: 'b',
                  content:
                    'API 사용, 서비스 이용 과정에서 자동으로 생성·수집되는 경우',
                },
                {
                  number: 'c',
                  content:
                    '고객센터 문의, 기술지원 요청, 이메일 교신 등을 통한 수집',
                },
                {
                  number: 'd',
                  content:
                    '제휴 서비스, 외부 연동(예: OAuth, Google, GitHub 등)을 통한 수집',
                },
              ],
            },
            {
              number: '3.1.2',
              content:
                '회원으로부터 수집하는 개인정보 항목은 3.2부터 3.6까지의 항목으로, 비회원으로부터 수집하는 개인정보 항목은 3.7의 항목으로 한다.',
            },
          ],
        },
        {
          title: '3.2 회원가입 및 계정 생성 시 수집 항목',
          items: [
            {
              number: '3.2.1',
              content: '개인회원(B2C)',
              subItems: [
                {
                  number: 'a',
                  content:
                    '필수항목: 이름(닉네임), 이메일 주소(ID), 비밀번호',
                },
                {
                  number: 'b',
                  content:
                    '선택항목: 소속(학교, 기관, 법인 등, 이하 "기관"), 직책, 관심 분야, 뉴스레터 수신 여부',
                },
              ],
            },
            {
              number: '3.2.2',
              content: '기관회원(B2B)',
              subItems: [
                {
                  number: 'a',
                  content:
                    '필수항목: 기관명, 사업자등록번호, 대표자명, 담당자 이름(닉네임), 이메일, 비밀번호',
                },
                {
                  number: 'b',
                  content: '선택항목: 기관 주소, 부서명, 결제 정보(청구서용)',
                },
              ],
            },
            {
              number: '3.2.3',
              content: '소셜 로그인(Google, LinkedIn) 이용 시',
              subItems: [
                {
                  number: 'a',
                  content:
                    '해당 계정의 고유 식별자(ID), 이메일, 프로필 이름',
                },
              ],
            },
          ],
        },
        {
          title: '3.3 서비스 이용 및 API 호출 과정에서 수집되는 항목',
          items: [
            {
              number: '3.3.1',
              content:
                'Spacemap은 위성·우주데이터 API 및 클라우드 서비스를 제공하는 과정에서 다음과 같은 기술적 정보를 자동으로 수집한다.',
              subItems: [
                {
                  number: 'a',
                  content:
                    '사용자 계정 식별 정보: ID, 비밀번호, 이메일 주소',
                },
                {
                  number: 'b',
                  content:
                    'API 인증 및 식별 정보: API Key, Access Token, Refresh Token, Client ID',
                },
                {
                  number: 'c',
                  content:
                    'API 이용 로그: 요청 일시, 호출 횟수, 요청 URL, 요청 데이터 유형',
                },
                {
                  number: 'd',
                  content:
                    'API 응답 로그: 응답 코드(Response Code), 처리시간, 응답 데이터 크기',
                },
                {
                  number: 'e',
                  content:
                    '접속 및 환경 정보: 접속 IP 주소, 브라우저 종류 및 버전, 운영체제(OS) 종류 및 버전, 접속 일시',
                },
                {
                  number: 'f',
                  content:
                    '서비스 운영 로그: 서비스 오류 로그, 시스템 성능 관련 로그',
                },
                {
                  number: 'g',
                  content:
                    'IP 주소, 접속 로그, 기기 정보(기기 종류, 운영체제(OS) 버전, MAC 주소)',
                },
              ],
            },
            {
              number: '3.3.2',
              content:
                '서비스 내 음성∙화상 회의 기능을 이용하는 경우 회사는 참여자의 오디오, 비디오 및 채팅 데이터를 수집한다. 해당 사용자 콘텐츠(오디오, 비디오, 채팅 등)는 음성∙화상 회의 서비스 제공 및 관련 기능 지원을 위한 목적으로만 처리되며, 회사는 이를 광고에 사용하거나 인공지능(AI) 모델 학습에 무단으로 사용하지 않는다.',
            },
          ],
        },
        {
          title: '3.4 결제 및 정산 관련 수집 항목',
          items: [
            {
              number: '3.4.1',
              content:
                '유료 서비스 이용 시 결제수단별로 결제 관련 정보가 수집될 수 있다. 결제 처리는 계좌이체 또는 외부 결제대행사(PG사)를 통해 이루어지며, 회사는 아래의 결제 정보를 수집한다.',
            },
            {
              number: '3.4.2',
              content: 'PayPal을 이용한 결제 시 회사가 수집하는 정보는 다음과 같다.',
              subItems: [
                {
                  number: 'a',
                  content:
                    '결제 식별 및 거래 정보: PayPal 거래 ID (Transaction ID), 결제 일시, 결제 금액, 결제 통화, 결제 상태(성공, 실패, 취소, 환불 등)',
                },
                {
                  number: 'b',
                  content:
                    '결제자 식별 정보: PayPal 계정 이메일 주소, PayPal 계정 고유 식별자(Payer ID 또는 이에 준하는 식별값)',
                },
                {
                  number: 'c',
                  content:
                    '상품 및 결제 내역 정보: 구매한 서비스 또는 플랜명, 구독 유형 (월간 / 연간 등), 결제 주기 정보, 결제 관련 참조 번호(Invoice ID 등)',
                },
                {
                  number: 'd',
                  content:
                    '세금 및 청구 관련 정보 (해당되는 경우): 세금 적용 여부, 세금 금액, 청구 국가 정보',
                },
              ],
            },
            {
              number: '3.4.3',
              content:
                '계좌이체를 이용한 결제 시 회사가 수집하는 정보는 다음과 같다. 계좌이체는 금융기관을 통해 처리되며, 회사는 입금 확인 및 회계 처리를 위한 최소 정보만을 확인한다.',
              subItems: [
                {
                  number: 'a',
                  content:
                    '결제 식별 및 거래 정보: 거래 일시, 입금 금액, 결제 통화, 거래 상태 (입금 완료 / 미입금 / 환불 등), 내부 거래 식별 번호 (Order ID 또는 Payment Reference)',
                },
                {
                  number: 'b',
                  content:
                    '입금자 식별 정보: 입금자명(단, 실제 입금 확인을 위해 금융기관이 제공하는 범위 내에서만 확인)',
                },
                {
                  number: 'c',
                  content:
                    '상품 및 결제 내역 정보: 구매한 서비스 또는 플랜명, 구독 유형 (월간 / 연간 등), 결제 대상 기간',
                },
                {
                  number: 'd',
                  content:
                    '세금 및 청구 관련 정보 (해당되는 경우): 세금계산서 발행 여부, 세금계산서 발행을 위한 사업자 정보(상호, 사업자등록번호, 대표자명, 사업장 주소, 이메일)',
                },
                {
                  number: 'e',
                  content:
                    '회사는 이용자의 계좌번호, 금융기관 로그인 정보, 계좌 비밀번호, 보안카드 정보 또는 OTP 정보를 수집하지 않는다.',
                },
              ],
            },
          ],
        },
        {
          title: '3.5 고객지원 및 기술문의 시 수집 항목',
          items: [
            {
              number: '3.5.1',
              content:
                'Spacemap 고객센터 또는 기술지원 채널을 통해 문의할 때 다음의 정보가 수집될 수 있다.',
              subItems: [
                {
                  number: 'a',
                  content: '문의자 이름, 이메일, 연락처',
                },
                {
                  number: 'b',
                  content: '소속기관명 또는 계정정보',
                },
                {
                  number: 'c',
                  content: '문의 내용, 첨부파일, 로그 데이터, 시스템 스냅샷 등',
                },
              ],
            },
          ],
        },
        {
          title: '3.6 자동수집 장치에 의한 항목',
          items: [
            {
              number: '3.6.1',
              content:
                '회사는 이용자 편의를 위해 다음과 같은 정보를 자동으로 수집할 수 있다.',
              subItems: [
                {
                  number: 'a',
                  content:
                    '쿠키(Cookie) 정보: 접속 빈도, 방문 시간, 선호 데이터 유형, 세션 정보',
                },
                {
                  number: 'b',
                  content:
                    '웹 비콘(Web Beacon), 로그 분석도구(GA, Matomo 등)를 통한 이용 패턴',
                },
              ],
            },
          ],
        },
        {
          title: '3.7 비회원 이용 시 수집 항목',
          items: [
            {
              number: '3.7.1',
              content:
                'Spacemap이 비회원에게 서비스를 제공하는 과정에서 다음과 같은 기술적 정보를 자동으로 수집한다.',
              subItems: [
                {
                  number: 'a',
                  content:
                    '접속 IP 주소, 접속 일시, 브라우저 종류 및 버전, 운영체제(OS) 종류 및 버전',
                },
                {
                  number: 'b',
                  content: '웹사이트 이용 로그',
                },
                {
                  number: 'c',
                  content: '필수 쿠키 정보',
                },
              ],
            },
            {
              number: '3.7.2',
              content:
                '비회원이 Spacemap 고객센터 또는 기술지원 채널을 통해 문의할 때 다음의 정보가 수집될 수 있다.',
              subItems: [
                {
                  number: 'a',
                  content:
                    '문의자 이름(또는 닉네임), 이메일 주소, 연락처(전화번호 또는 이메일 중 이용자가 제공한 경우)',
                },
                {
                  number: 'b',
                  content:
                    '소속기관명(이용자가 선택적으로 기재한 경우)',
                },
                {
                  number: 'c',
                  content: '문의 유형(일반 문의, 도입 문의, 견적 문의 등)',
                },
                {
                  number: 'd',
                  content:
                    '문의 내용, 첨부파일, 문의 해결을 위하여 이용자가 선택적으로 제공한 로그 데이터 또는 서비스 스냅샷(캡처화면) 등',
                },
              ],
            },
            {
              number: '3.7.3',
              content: '회사는 비회원으로부터 다음의 정보는 수집하지 않는다.',
              subItems: [
                {
                  number: 'a',
                  content: '계정 정보: ID, 비밀번호',
                },
                {
                  number: 'b',
                  content:
                    'API 인증 정보: API Key, Access Token, Refresh Token, Client ID',
                },
                {
                  number: 'c',
                  content: '결제 정보 일체',
                },
                {
                  number: 'd',
                  content: '고유식별정보(주민등록번호, 여권번호 등)',
                },
                {
                  number: 'e',
                  content: '결제 이력, 세금계산서 정보',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      title: '4 개인정보의 보유 및 이용기간',
      subsections: [
        {
          title: '4.1 기본원칙',
          items: [
            {
              number: '4.1.1',
              content:
                '회사는 회원이 탈퇴하거나, 개인정보의 수집 및 이용목적이 달성되거나, 보유기간이 경과한 경우에는 지체 없이 해당 정보를 파기한다. 단, 회사는 다음의 기준에 따라 개인정보를 일정기간 보유한다.',
              table: {
                headers: ['구분', '보유항목', '보유기간', '보유목적'],
                rows: [
                  {
                    cells: [
                      { content: '서비스 부정이용 기록' },
                      {
                        content:
                          '서비스 이용로그 및 API 이용로그',
                      },
                      { content: '회원 탈퇴 시로부터 1년' },
                      { content: '부정 이용 회원의 재가입 제한' },
                    ],
                  },
                  {
                    cells: [
                      { content: '기술지원 문의기록' },
                      { content: '이메일, 연락처, 문의 내용' },
                      { content: '처리 완료 후 2년' },
                      { content: '서비스 품질관리' },
                    ],
                  },
                ],
              },
            },
          ],
        },
        {
          title: '4.2 법령에 따른 보존기간',
          items: [
            {
              number: '4.2.1',
              content:
                '회사는 관계 법령에서 정한 기간 동안 개인정보를 보존해야 하는 경우, 해당 법령에서 규정한 기간 동안 개인정보를 보유한다.',
              table: {
                headers: ['구분', '보유항목', '보유기간'],
                rows: [
                  {
                    cells: [
                      {
                        content:
                          '전자상거래 등에서의 소비자 보호에 관한 법률',
                      },
                      {
                        content:
                          '계약, 결제, 청약철회, 대금결제 내역',
                      },
                      { content: '5년' },
                    ],
                  },
                  {
                    cells: [
                      {
                        content:
                          '전자상거래 등에서의 소비자 보호에 관한 법률',
                      },
                      {
                        content: '소비자 불만 또는 분쟁처리 기록',
                      },
                      { content: '3년' },
                    ],
                  },
                  {
                    cells: [
                      { content: '통신비밀보호법' },
                      { content: '로그인 기록, IP 접속이력' },
                      { content: '3개월' },
                    ],
                  },
                  {
                    cells: [
                      { content: '국세기본법 및 법인세법' },
                      {
                        content: '거래 관련 회계자료, 세금계산서',
                      },
                      { content: '5년' },
                    ],
                  },
                ],
              },
            },
          ],
        },
        {
          title: '4.3 예외적 보유사유',
          items: [
            {
              number: '4.3.1',
              content:
                '다음의 경우에는 보유기간이 경과하였더라도 예외적으로 개인정보를 보유할 수 있다.',
              subItems: [
                {
                  number: 'a',
                  content: '이용자가 동의한 경우',
                },
                {
                  number: 'b',
                  content:
                    '관계 법령에 따라 조사나 소송이 진행 중인 경우',
                },
                {
                  number: 'c',
                  content:
                    '부정 이용, 해킹 등 보안사고 대응을 위해 일시적 보관이 필요한 경우',
                },
                {
                  number: 'd',
                  content:
                    '서비스 이용에 따른 회원 또는 제3자와의 채권∙채무관계가 잔존하는 경우',
                },
              ],
            },
            {
              number: '4.3.2',
              content:
                '이 경우, 보유 목적이 종료되는 즉시 개인정보는 파기된다.',
            },
          ],
        },
        {
          title: '4.4 보유기간 만료 시 조치',
          items: [
            {
              number: '4.4.1',
              content:
                '보유기간이 만료된 개인정보는 파기 절차에 따라 안전하게 삭제된다. 단, 비식별화되어 통계용으로 전환된 정보는 본 방침 제9장(파기절차 및 방법)에 따라 별도 관리한다.',
            },
          ],
        },
      ],
    },
    {
      title: '5 개인정보의 제3자 제공 (Provision of Third Parties)',
      subsections: [
        {
          title: '5.1 기본 원칙',
          items: [
            {
              number: '5.1.1',
              content:
                '회사는 이용자의 개인정보를 원칙적으로 제3자에게 제공하지 않는다. 다만, 다음 각 호의 경우에는 예외적으로 제공할 수 있다.',
              subItems: [
                {
                  number: 'a',
                  content:
                    '이용자가 사전에 제3자 제공에 명시적으로 동의한 경우',
                },
                {
                  number: 'b',
                  content:
                    '법령에 따라 수사기관, 법원, 행정기관 등 공공기관의 적법한 요청이 있는 경우',
                },
                {
                  number: 'c',
                  content:
                    '서비스 제공을 위해 불가피하게 외부기관과의 협력이 필요한 경우',
                },
                {
                  number: 'd',
                  content:
                    '통계작성·학술연구 등의 목적을 위해 개인을 식별할 수 없는 형태로 제공하는 경우',
                },
              ],
            },
          ],
        },
        {
          title: '5.2 통계 및 연구목적 제공',
          items: [
            {
              number: '5.2.1',
              content:
                '회사는 개인 식별이 불가능하도록 비식별화된 형태로 학술연구, 통계작성, 공공정책 수립 등의 목적에 한해 제3자 또는 공공기관에 데이터를 제공할 수 있다.',
            },
            {
              number: '5.2.2',
              content:
                '이 경우, 재식별 가능성이 없도록 데이터 결합·분석 과정에서 추가 암호화 및 익명화를 적용한다.',
            },
          ],
        },
      ],
    },
    {
      title: '6 개인정보의 처리 위탁',
      subsections: [
        {
          title: '6.1 기본원칙',
          items: [
            {
              number: '6.1.1',
              content:
                '회사는 원칙적으로 이용자의 개인정보를 자체적으로 처리하되, 서비스의 효율적 제공을 위해 필요한 경우 다음과 같은 외부업체에 그 처리를 위탁할 수 있다.',
            },
            {
              number: '6.1.2',
              content:
                '회사는 개인정보 보호법 제26조에 따라 위탁계약 체결 시 수탁자가 개인정보를 안전하게 처리하도록 필요한 관리·감독을 수행한다.',
            },
          ],
        },
        {
          title: '6.2 주요 위탁업무 현황',
          items: [
            {
              number: '6.2.1',
              content:
                '회사는 다음과 같은 범위 내에서 개인정보 처리업무를 외부에 위탁할 수 있다.',
              table: {
                headers: [
                  '위탁받는 자(수탁자)',
                  '위탁 업무의 내용',
                  '재수탁자',
                ],
                rows: [
                  {
                    cells: [
                      {
                        content: 'Amazon Web Services, Google Cloud Platform',
                      },
                      {
                        content:
                          '클라우드 서버 운영, 데이터 저장 및 백업 관리',
                      },
                      {
                        content:
                          'Amazon Web Services: https://aws.amazon.com/ko/privacy/?nc1=f_pr\nGoogle Cloud Platform: https://cloud.google.com/terms/cloud-privacy-notice?hl=ko',
                      },
                    ],
                  },
                  {
                    cells: [
                      { content: 'PayPal Pte. Ltd.' },
                      { content: '결제 처리, 환불, 정산 업무' },
                      {
                        content:
                          'https://www.paypal.com/kr/legalhub/paypal/privacy-full',
                      },
                    ],
                  },
                  {
                    cells: [
                      { content: 'Zendesk Inc., Freshworks Inc.' },
                      {
                        content:
                          '고객문의 관리, 기술지원 시스템 운영',
                      },
                      {
                        content:
                          'Zendesk: https://www.zendesk.kr/company/agreements-and-terms/privacy-notice/\nFreshworks: https://www.freshworks.com/privacy/',
                      },
                    ],
                  },
                  {
                    cells: [
                      { content: '(주)메일플러그' },
                      { content: '이메일, 알림 발송 대행' },
                      {
                        content:
                          'https://mypage.mailplug.com/terms/private',
                      },
                    ],
                  },
                  {
                    cells: [
                      { content: 'Google LLC' },
                      {
                        content:
                          '서비스 이용 통계 분석, 접속 및 이용 패턴 분석, 서비스 개선을 위한 분석 제공, Google Analytics 이용약관 및 Data Processing Terms에 따른 범위 내 처리',
                      },
                      {
                        content:
                          'https://policies.google.com/privacy?hl=ko',
                      },
                    ],
                  },
                ],
              },
            },
            {
              number: '',
              content:
                '※ 위탁업체는 서비스 운영 상황에 따라 변경될 수 있으며, 변경 시 회사는 즉시 홈페이지 공지사항을 통해 고지한다.',
            },
          ],
        },
        {
          title: '6.3 주요 위탁업무 현황',
          items: [
            {
              number: '6.3.1',
              content:
                '회사는 개인정보 처리위탁 시 다음 사항이 계약서 또는 문서에 명시되도록 관리한다.',
              subItems: [
                {
                  number: 'a',
                  content: '위탁업무의 목적 및 범위',
                },
                {
                  number: 'b',
                  content: '재위탁 제한',
                },
                {
                  number: 'c',
                  content:
                    '개인정보의 기술적·관리적 보호조치',
                },
                {
                  number: 'd',
                  content: '수탁자의 접근제한 및 보안점검',
                },
                {
                  number: 'e',
                  content: '사고 발생 시 보고 및 책임',
                },
                {
                  number: 'f',
                  content:
                    '계약 종료 시 개인정보의 반환 또는 삭제 의무',
                },
              ],
            },
            {
              number: '6.3.2',
              content:
                '또한, 회사는 수탁자의 개인정보 처리현황을 정기적으로 점검하고, 위반사항이 발견될 경우 즉시 시정조치를 요구한다.',
            },
          ],
        },
        {
          title: '6.4 재위탁의 제한',
          items: [
            {
              number: '6.4.1',
              content:
                '수탁자는 회사의 사전 서면 동의 없이 개인정보 처리업무를 제3자에게 재위탁할 수 없다.',
            },
            {
              number: '6.4.2',
              content:
                '재위탁이 불가피한 경우, 수탁자는 회사의 승인을 받은 후 동일한 보호조치를 이행해야 한다.',
            },
          ],
        },
        {
          title: '6.5 위탁업체의 관리 및 점검',
          items: [
            {
              number: '6.5.1',
              content:
                '회사는 수탁자에 대해 연 1회 이상 보안점검 또는 서면평가를 실시하며, 필요 시 현장 실사를 수행할 수 있다.',
            },
            {
              number: '6.5.2',
              content:
                '위탁업체가 개인정보를 부적절하게 처리하거나 보안사고가 발생한 경우, 회사는 계약을 즉시 해지하거나 해당 업무를 회수할 수 있다.',
            },
          ],
        },
        {
          title: '6.6 위탁업체 변경 시 통지',
          items: [
            {
              number: '6.6.1',
              content:
                '회사는 위탁업체의 변경, 추가 또는 계약 종료가 발생한 경우, 그 사실과 내용을 홈페이지를 통해 공개한다. 단, 긴급 보안 대응 등 불가피한 사유로 사전 공지가 어려운 경우, 사후 30일 이내에 이를 고지한다.',
            },
          ],
        },
      ],
    },
    {
      title: '7 개인정보의 국외 이전',
      subsections: [
        {
          title: '7.1 기본 원칙',
          items: [
            {
              number: '7.1.1',
              content:
                '회사는 원칙적으로 개인정보를 대한민국 내에서 처리·보관한다. 다만, 서비스 운영 및 클라우드 인프라 유지관리 등을 위해 해외에 소재한 서버 또는 협력기관으로 개인정보를 이전할 수 있다.',
            },
            {
              number: '7.1.2',
              content:
                '회사는 국외 이전 시 「개인정보 보호법」 제28조의8 및 관련 규정에 따라 이용자의 권익이 침해되지 않도록 적절한 보호조치를 이행한다.',
            },
          ],
        },
        {
          title: '7.2 국외 이전 대상 및 이전 현황',
          items: [
            {
              number: '7.2.1',
              content:
                'Spacemap은 다음과 같은 목적 및 범위 내에서 개인정보를 국외로 이전할 수 있다.',
            },
            {
              number: '',
              content:
                '국외 이전의 근거: 개인정보 보호법 제28조의8 제1항 제3호 가목',
              table: {
                headers: [
                  '수탁자\n(이전받는 자)',
                  '국가',
                  '이전 항목',
                  '이전 목적',
                  '보유ㆍ이용\n기간',
                  '이전 방법 및\n시기',
                  '연락처',
                ],
                rows: [
                  {
                    cells: [
                      { content: 'Amazon Web Services, Inc.' },
                      { content: '미국' },
                      {
                        content:
                          '계정정보, 로그데이터, API 호출기록, 백업 데이터',
                      },
                      {
                        content: '클라우드 서버 운영 및 데이터 저장',
                      },
                      {
                        content:
                          '본 개인정보처리방침에 규정된 보관기간과 일치함',
                      },
                      {
                        content:
                          '클라우드 서버를 통한 실시간 데이터 처리 및 저장 시 네트워크를 통해 자동으로 이전',
                      },
                      { content: 'aws-korea-privacy@amazon.com' },
                    ],
                  },
                  {
                    cells: [
                      {
                        content:
                          'Google Cloud Platform (Alphabet Inc.)',
                      },
                      { content: '미국, 싱가포르' },
                      { content: '로그 데이터, 시스템 설정정보' },
                      { content: '데이터 처리 및 API 응답 관리' },
                      {
                        content:
                          '본 개인정보처리방침에 규정된 보관기간과 일치함',
                      },
                      { content: '' },
                      { content: 'googlekrsupport@google.com' },
                    ],
                  },
                  {
                    cells: [
                      { content: 'PayPal Pte. Ltd.' },
                      { content: '미국' },
                      {
                        content:
                          '결제 식별 및 거래 정보, 결제자 식별 정보, 상품 및 결제 내역 정보, 세금 및 청구 관련 정보',
                      },
                      { content: '결제 처리, 환불, 정산 업무' },
                      {
                        content:
                          '본 개인정보처리방침에 규정된 보관기간과 일치함',
                      },
                      { content: '' },
                      { content: 'paypal@generalagent.co.kr' },
                    ],
                  },
                  {
                    cells: [
                      { content: 'Zendesk Inc.' },
                      {
                        content: '미국, 유럽경제지역, 일본, 호주',
                      },
                      {
                        content: '이름(닉네임), 이메일 주소(ID), 문의내용',
                      },
                      {
                        content: '고객문의 관리, 기술지원 시스템 운영',
                      },
                      {
                        content:
                          '본 개인정보처리방침에 규정된 보관기간과 일치함',
                      },
                      { content: '' },
                      { content: 'privacy@zendesk.com' },
                    ],
                  },
                  {
                    cells: [
                      { content: 'Freshworks Inc.' },
                      { content: '미국' },
                      {
                        content: '이름(닉네임), 이메일 주소(ID), 문의내용',
                      },
                      {
                        content: '고객문의 관리, 기술지원 시스템 운영',
                      },
                      {
                        content:
                          '본 개인정보처리방침에 규정된 보관기간과 일치함',
                      },
                      { content: '' },
                      { content: 'dpo@freshworks.com' },
                    ],
                  },
                  {
                    cells: [
                      { content: 'Google LLC' },
                      { content: '미국' },
                      {
                        content:
                          '쿠키, 기기 브라우저 관련 데이터, IP 주소, 사이트/앱 활동 수집 (개인 식별 정보 미전송)',
                      },
                      {
                        content: '서비스 이용 통계 분석 및 품질 개선',
                      },
                      { content: '38개월' },
                      {
                        content:
                          '웹 사이트 내에 방문자 서비스 이용 시점에 네트워크를 통한 전송',
                      },
                      { content: 'googlekrsupport@google.com' },
                    ],
                  },
                ],
              },
            },
            {
              number: '',
              content:
                '※ 위 표의 수탁자 및 국가, 항목은 서비스 제공 환경에 따라 변경될 수 있으며, 변경 시 홈페이지 공지사항을 통해 사전 고지한다.',
            },
          ],
        },
        {
          title: '7.3 국외 이전의 거부',
          items: [
            {
              number: '7.3.1',
              content:
                '이용자는 국외 이전에 대한 동의를 거부할 수 있으며, 거부 시 서비스 이용이 제한될 수 있다.',
            },
            {
              number: '7.3.2',
              content:
                '또한 이용자는 국외 이전된 자신의 개인정보에 대해 열람, 정정, 삭제, 처리정지 등을 요청할 수 있으며, 회사는 기술적으로 가능한 범위 내에서 이를 지원한다.',
            },
          ],
        },
      ],
    },
    {
      title: '8 가명정보 처리에 관한 사항',
      subsections: [
        {
          title: '8.1',
          items: [
            {
              number: '8.1',
              content:
                '회사는 수집한 개인정보를 개인정보 보호법 제28조의2에 따라 통계작성, 과학적 연구, 공익적 기록보존 등을 위하여 특정 개인을 알아볼 수 없도록 가명처리하여 다음과 같이 활용한다.',
            },
            {
              number: '8.1.1',
              content:
                '이용 목적: 서비스 품질 개선, 기능 고도화 및 신규 서비스 개발을 위한 통계 작성 및 과학적 분석',
            },
            {
              number: '8.1.2',
              content:
                '이용 항목: 서비스 이용 로그(API 호출 횟수, 요청·응답 시각, 응답 코드, 처리 시간 등), 서비스 기능별 사용 이력 및 사용 빈도, 회원 유형(기관회원/일반회원의 구분), 이용 중인 서비스 플랜 및 과금 유형, 접속 환경 정보(브라우저 종류, 운영체제 종류, 국가 또는 권역 단위 위치 정보)',
            },
            {
              number: '8.1.3',
              content:
                '보유 및 이용기간: 가명정보 분석 완료시까지(가명처리 완료일로부터 최대 10년)',
            },
          ],
        },
        {
          title: '8.2',
          items: [
            {
              number: '8.2',
              content:
                '회사는 아래와 같이 가명정보의 안전성 확보조치를 취한다.',
            },
            {
              number: '8.2.1',
              content:
                '관리적 조치: 가명정보 내부관리계획 수립 및 시행, 정기적 직원 교육',
            },
            {
              number: '8.2.2',
              content:
                '기술적 조치: 가명정보와 추가정보의 분리 보관, 추가 정보 불필요 시 파기, 가명정보와 추가정보에 대한 접근 권한의 분리 접근통제시스템 설치 및 기타 관련 보호조치, 가명정보 처리기록 및 접근 기록의 보관·점검, 보안프로그램 설치 등',
            },
            {
              number: '8.2.3',
              content:
                '물리적 조치: 가명정보가 보관된 서버실, 자료보관실 등의 접근통제',
            },
          ],
        },
      ],
    },
    {
      title: '9 개인정보의 파기절차 및 방법',
      subsections: [
        {
          title: '9.1 기본 원칙',
          items: [
            {
              number: '9.1.1',
              content:
                '회사는 개인정보 보유기간의 경과, 처리 목적의 달성, 또는 이용자의 삭제 요청 등 그 보유가 불필요하게 된 경우에는 해당 정보를 지체 없이 파기한다.',
            },
            {
              number: '9.1.2',
              content:
                '개인정보의 파기는 원칙적으로 복구 및 재생이 불가능한 방식으로 수행되며, 파기된 정보는 어떠한 경우에도 재이용되지 않는다.',
            },
          ],
        },
        {
          title: '9.2 파기 절차',
          items: [
            {
              number: '9.2.1',
              content: '파기 사유의 확인',
              subItems: [
                {
                  number: 'a',
                  content:
                    '개인정보의 보유기간 만료, 서비스 탈퇴, 계약 종료, 또는 관련 법령상 보존기간 종료 여부를 검토한다.',
                },
              ],
            },
            {
              number: '9.2.2',
              content: '파기 대상의 분류',
              subItems: [
                {
                  number: 'a',
                  content:
                    '서비스 DB, 백업 서버, 로그 서버, 파일 저장소 등 파기 대상 정보를 분리한다.',
                },
              ],
            },
            {
              number: '9.2.3',
              content: '관리책임자 승인 절차',
              subItems: [
                {
                  number: 'a',
                  content:
                    '개인정보보호책임자(DPO)의 승인을 거쳐 파기 여부를 확정한다.',
                },
              ],
            },
          ],
        },
        {
          title: '9.3 파기 방법',
          items: [
            {
              number: '9.3.1',
              content: '전자적 파일 형태의 정보',
              subItems: [
                {
                  number: 'a',
                  content:
                    '데이터베이스(DB) 또는 파일시스템에 저장된 개인정보는 복구 불가능한 방식으로 삭제한다. 예: Secure Erase, DB Overwrite, Crypto Erase 등',
                },
                {
                  number: 'b',
                  content:
                    '클라우드 환경에서는 수탁자(AWS, GCP 등)의 보안정책에 따라 다중 삭제 절차를 병행한다.',
                },
              ],
            },
            {
              number: '9.3.2',
              content: '문서 등 인쇄물 형태의 정보',
              subItems: [
                {
                  number: 'a',
                  content:
                    '종이 문서, 출력물 등은 분쇄기(Shredder) 또는 소각을 통해 물리적으로 파기한다.',
                },
              ],
            },
          ],
        },
        {
          title: '9.4 파기 책임 및 감독',
          items: [
            {
              number: '9.4.1',
              content:
                '회사는 개인정보 파기와 관련하여 다음의 관리체계를 운영하며, 개인정보책임자의 승인을 받아 삭제한다.',
              subItems: [
                {
                  number: 'a',
                  content:
                    '개인정보보호책임자(DPO): 파기 정책 승인 및 점검',
                },
                {
                  number: 'b',
                  content:
                    '개인정보취급자: 파기대상 데이터의 식별 및 실행',
                },
                {
                  number: 'c',
                  content:
                    '정보보안팀: 삭제 절차 검증 및 기술적 복구방지 조치 확인',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      title: '10 이용자 및 법정대리인의 권리',
      subsections: [
        {
          title: '10.1 이용자의 권리',
          items: [
            {
              number: '10.1.1',
              content:
                '이용자는 언제든지 자신의 개인정보에 대하여 다음 각 호의 권리를 행사할 수 있다.',
              subItems: [
                {
                  number: 'a',
                  content: '개인정보 열람 요구',
                },
                {
                  number: 'b',
                  content: '개인정보 정정 및 삭제 요구',
                },
                {
                  number: 'c',
                  content: '개인정보 처리정지 요구',
                },
                {
                  number: 'd',
                  content: '동의 철회',
                },
                {
                  number: 'e',
                  content:
                    '기타 개인정보 보호법상 이용자가 보유한 권리',
                },
              ],
            },
          ],
        },
        {
          title: '10.2 권리행사의 방법',
          items: [
            {
              number: '10.2.1',
              content:
                '이용자는 서비스 내 "계정 관리" 메뉴 또는 개인정보보호 책임자 또는 담당부서에 서면, 이메일, 전화 등의 방법으로 권리를 행사할 수 있다.',
            },
            {
              number: '10.2.2',
              content:
                '회사는 요청을 받은 날로부터 10일 이내에 그 처리 결과를 통지한다.',
            },
            {
              number: '10.2.3',
              content:
                '이용자가 대리인을 통하여 요청하는 경우, 대리권을 증명하는 위임장을 제출해야 한다.',
            },
            {
              number: '10.2.4',
              content:
                '회사는 이용자의 권리행사 요청이 법령상 예외사유에 해당하거나, 타인의 권리를 침해할 우려가 있는 경우에는 전부 또는 일부를 제한할 수 있다.',
            },
          ],
        },
        {
          title: '10.3 권리행사에 따른 조치',
          items: [
            {
              number: '10.3.1',
              content:
                '회사는 이용자의 권리행사 요청을 성실히 검토하고, 처리 결과를 이메일 또는 알림을 통해 통지한다.',
            },
            {
              number: '10.3.2',
              content:
                '개인정보 보호법 등 관련 법령에 따라 이용자의 권리가 제한되는 경우, 회사는 이용자의 권리 행사를 거부할 수 있다.',
            },
            {
              number: '10.3.3',
              content:
                '요청이 거부되는 경우, 그 사유와 이의제기 절차를 함께 안내한다. 이용자의 권리행사로 인해 서비스 제공에 일부 제약이 발생할 수 있으며, 그에 따른 불이익은 회사가 아닌 이용자 본인에게 귀속된다.',
            },
          ],
        },
      ],
    },
    {
      title: '11 개인정보 자동수집 장치의 설치·운영 및 거부',
      subsections: [
        {
          title: '11.1 기본 원칙',
          items: [
            {
              number: '11.1.1',
              content:
                '회사는 이용자 맞춤형 서비스를 제공하기 위해 쿠키(Cookie), 웹 비콘(Web Beacon), 로그 분석 도구 등 자동수집 장치를 사용할 수 있다.',
            },
            {
              number: '11.1.2',
              content:
                '이러한 기술은 이용자의 단말기에 저장되거나, 이용자의 브라우저 및 서버 간 통신 과정에서 자동으로 생성·기록된다.',
            },
          ],
        },
        {
          title: '11.2 쿠키(Cookie)의 정의 및 목적',
          items: [
            {
              number: '11.2.1',
              content:
                '쿠키는 Spacemap 서버가 이용자의 웹브라우저로 전송하는 소량의 텍스트 파일로, 이용자의 단말기(PC, 모바일 등)에 저장되어 다음과 같은 목적을 위해 사용된다.',
              subItems: [
                {
                  number: 'a',
                  content:
                    '세션 관리: 로그인 상태 유지 및 인증정보 관리',
                },
                {
                  number: 'b',
                  content:
                    '이용자 편의성 향상: 선호 데이터셋, 언어설정, UI 환경 저장',
                },
                {
                  number: 'c',
                  content:
                    '서비스 성능 분석: 이용 빈도, 접속 시간, 방문 경로 등 트래픽 분석',
                },
                {
                  number: 'd',
                  content:
                    '맞춤형 콘텐츠 제공: 이용자의 관심 분야 기반 데이터 추천',
                },
              ],
            },
            {
              number: '11.2.2',
              content:
                '쿠키에는 개인식별이 가능한 정보가 포함되지 않으며, Spacemap은 쿠키를 통해 이용자의 행동패턴을 익명화된 형태로만 분석한다.',
            },
          ],
        },
        {
          title: '11.3 쿠키의 설치 및 운영',
          items: [
            {
              number: '11.3.1',
              content:
                'Spacemap은 이용자의 단말기에 쿠키를 저장하고, 이를 이용하여 이용자의 로그인 상태 유지, 데이터 조회 이력 관리, API 호출 환경 설정 등의 기능을 수행한다.',
            },
            {
              number: '11.3.2',
              content:
                '쿠키는 이용자가 브라우저를 종료하거나 로그아웃 시 자동으로 삭제될 수 있으며, 일부 장기 쿠키는 이용자의 설정에 따라 일정 기간 보관될 수 있다.',
            },
            {
              number: '11.3.3',
              content:
                '쿠키의 저장기간은 서비스 목적에 따라 최대 1년 이내로 제한한다.',
            },
          ],
        },
        {
          title: '11.4 웹 비콘(Web Beacon) 및 로그분석도구의 사용',
          items: [
            {
              number: '11.4.1',
              content:
                'Spacemap은 서비스 개선과 품질 모니터링을 위해 웹 비콘, 로그분석도구, AI 기반 이용통계 모듈을 사용할 수 있다.',
            },
            {
              number: '11.4.2',
              content: '주요 사용 도구 예시는 다음과 같다.',
              subItems: [
                {
                  number: 'a',
                  content:
                    'Google Analytics / Matomo: 방문자 수, 페이지 체류시간, 클릭 이벤트 분석',
                },
                {
                  number: 'b',
                  content:
                    'AWS CloudWatch / Datadog: 서버 상태, API 응답시간, 트래픽 모니터',
                },
                {
                  number: 'c',
                  content:
                    'Hotjar 또는 Amplitude: UI/UX 개선을 위한 사용자 동선 분석',
                },
              ],
            },
            {
              number: '11.4.3',
              content:
                '이들 도구를 통해 수집되는 정보는 IP 주소, 브라우저 종류, 세션 ID, 방문 시간, 이벤트 로그 등이며, 개인식별이 불가능한 비식별 정보만을 분석에 사용한다.',
            },
          ],
        },
        {
          title: '11.5 자동수집 정보의 거부 방법',
          items: [
            {
              number: '11.5.1',
              content:
                '이용자는 쿠키 저장을 거부하거나 삭제할 수 있다. 단, 쿠키 거부 시 로그인 유지, 맞춤형 설정 등 일부 기능이 제한될 수 있다.',
            },
            {
              number: '11.5.2',
              content: '브라우저별 설정 방법은 다음과 같다.',
              subItems: [
                {
                  number: 'a',
                  content:
                    'Chrome: 설정 → 개인정보 및 보안 → 쿠키 및 기타 사이트 데이터 → "모든 쿠키 차단" 선택',
                },
                {
                  number: 'b',
                  content:
                    'Microsoft Edge: 설정 → 개인정보, 검색 및 서비스 → 쿠키 및 사이트 권한 → 쿠키 관리 및 삭제',
                },
                {
                  number: 'c',
                  content:
                    'Safari: 설정 → 개인정보 보호 → "모든 쿠키 차단" 선택',
                },
                {
                  number: 'd',
                  content:
                    'Firefox: 설정 → 개인정보 및 보안 → 쿠키 및 사이트 데이터 → "데이터 지우기" 선택',
                },
              ],
            },
            {
              number: '11.5.3',
              content:
                '또한, 이용자는 Google Analytics 차단용 브라우저 부가 기능(Add-on)을 설치하여 GA 기반 수집을 거부할 수 있다.',
            },
          ],
        },
        {
          title: '11.6 모바일 앱 환경에서의 자동수집',
          items: [
            {
              number: '11.6.1',
              content:
                'Spacemap 모바일 앱(또는 API 연동 클라이언트)이 제공되는 경우, 이용자의 앱 내 행동 로그, 디바이스 ID, 앱 버전, 오류 로그 등이 수집될 수 있다. 이는 앱 안정성 분석 및 기술지원 목적에 한하며, 광고성 트래킹 또는 맞춤 광고에는 사용되지 않는다.',
            },
          ],
        },
        {
          title: '11.7 자동수집 장치의 보안조치',
          items: [
            {
              number: '11.7.1',
              content:
                '회사는 쿠키 및 자동수집 정보를 안전하게 관리하기 위해 다음과 같은 보안조치를 적용한다.',
              subItems: [
                {
                  number: 'a',
                  content:
                    '쿠키 내 개인정보(예: 이메일, 이름 등)는 저장하지 않음',
                },
                {
                  number: 'b',
                  content: '전송 시 HTTPS를 통한 암호화',
                },
                {
                  number: 'c',
                  content: '세션 쿠키의 유효시간 제한',
                },
                {
                  number: 'd',
                  content: '비정상 접근 탐지 시 즉시 무효화',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      title: '12 개인정보의 안전성 확보조치',
      subsections: [
        {
          title: '12.1 기본 원칙',
          items: [
            {
              number: '12.1.1',
              content:
                '회사는 개인정보가 분실, 도난, 누출, 위조, 변조 또는 훼손되지 않도록 「개인정보 보호법」 제29조 및 관계 법령에서 정하는 기술적·관리적·물리적 조치를 시행한다.',
            },
            {
              number: '12.1.2',
              content:
                '또한, 국제보안표준(ISO/IEC 27001) 및 클라우드 보안기준(CSAP)을 참고하여 Spacemap 서비스 전반에 걸친 정보보호 체계를 구축·운영한다.',
            },
          ],
        },
        {
          title: '12.2 관리적 보호조치',
          items: [
            {
              number: '12.2.1',
              content:
                '회사는 내부관리계획 수립 및 시행, 정기적 직원 교육, 전담조직 운영 조치를 이행한다.',
            },
          ],
        },
        {
          title: '12.3 기술적 보호조치',
          items: [
            {
              number: '12.3.1',
              content:
                '회사는 개인정보처리시스템에 대한 등의 접근 권한의 관리, 접근통제시스템 설치 및 기타 관련 보호 조치, 인터넷망 차단 조치, 개인정보의 암호화, 접속기록의 보관 및 점검, 보안프로그램 설치 및 갱신, 개인정보처리시스템의 취약점 점검 및 보완 조치를 이행한다.',
            },
          ],
        },
        {
          title: '12.4 물리적 보호조치',
          items: [
            {
              number: '12.4.1',
              content:
                '회사는 서버실, 자료보관실 등 개인정보가 저장된 구역의 접근통제 서류·보조저장매체 등을 잠금장치가 있는 안전한 장소에 보관, 재해·재난에 대한 안전조치, 보조저장매체의 반출·입 통제 조치를 이행한다.',
            },
          ],
        },
      ],
    },
    {
      title: '13 개인정보보호 책임자 및 문의처',
      subsections: [
        {
          title: '13.1 개인정보보로 책임자 지정',
          items: [
            {
              number: '13.1.1',
              content:
                '회사는 개인정보의 처리에 관한 업무를 총괄하고, 개인정보 관련 불만처리 및 피해구제를 위하여 아래와 같이 개인정보보호 책임자(DPO, Data Protection Officer)를 지정한다.',
              subItems: [
                {
                  number: 'a',
                  content:
                    '개인정보보호 책임자 (Data Protection Officer, DPO)\n· 성명: [작성 예정]\n· 직책: 개인정보보호책임자 / Data Protection Officer\n· 소속: SPACEMAP 운영본부\n· 연락처: [이메일 주소] / [전화번호]',
                },
                {
                  number: 'b',
                  content:
                    '개인정보보호 담당부서 (Privacy Operations Team)\n· 부서명: 데이터보호·보안팀\n· 담당자: [작성 예정]\n· 이메일: privacy@spacemap42.com\n· 전화번호: [대표번호 또는 직통번호]',
                },
              ],
            },
            {
              number: '13.1.2',
              content:
                '회사는 이용자의 개인정보 관련 문의에 대해 성실하고 신속하게 답변·처리할 의무를 가진다.',
            },
            {
              number: '13.1.3',
              content:
                '이용자는 다음 경로를 통해 개인정보에 관한 문의를 할 수 있다.\n이메일: privacy@spacemap42.com\n홈페이지 내 "문의하기(Contact Support)" 메뉴\n우편: (우) [주소 입력] [SPACEMAP 본사 주소] 개인정보보호 담당자 앞',
            },
          ],
        },
      ],
    },
    {
      title: '14 개정',
      subsections: [
        {
          title: '14.1 시행일',
          items: [
            {
              number: '14.1.1',
              content:
                '이 개인정보처리방침은 2026 01 20부터 시행한다.',
            },
          ],
        },
      ],
    },
  ],
};
